import {
  ACCUMULATE_CONTENT_ANALYSIS_DATA,
  ACCUMULATE_VISUAL_ASSETS_DATA,
  ACCUMULATE_TEXT_CONTENT_DATA,
  ACCUMULATE_VIDEO_SEGMENTS_DATA,
  CLEAR_CONTENT_COMPOSER_DATA,
  SET_COMPOSITION_TICKET_ID,
} from "../actions/contentComposerActions";

const initialState = {
  ticketId: null, // Current ticket being composed
  contentAnalysis: {
    quotes: [],
    keyMoments: [],
    frames: [],
    topics: [],
    visualAnalysis: null,
  },
  visualAssets: {
    quoteCards: [],
    carousels: [],
    storyCovers: [],
    thumbnails: [],
  },
  textContent: {
    blog: null,
    twitterThread: null,
    linkedInArticle: null,
    newsletter: null,
    descriptions: null,
    metadata: null,
  },
  videoSegments: {
    segments: [],
    s3Keys: {},
  },
  // Presigned URLs accumulated from all agents
  presignedUrls: {},
  // Frame URLs mapped for easy lookup
  frameUrls: {},
};

const contentComposerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPOSITION_TICKET_ID:
      console.log("contentComposerReducer - Setting ticketId:", action.payload);
      return {
        ...state,
        ticketId: action.payload,
      };

    case ACCUMULATE_CONTENT_ANALYSIS_DATA:
      console.log(
        "contentComposerReducer - Accumulating ContentAnalysis data:",
        {
          quotesCount: action.payload.quotes?.length || 0,
          keyMomentsCount: action.payload.keyMoments?.length || 0,
          framesCount: action.payload.frames?.length || 0,
        }
      );
      return {
        ...state,
        contentAnalysis: {
          quotes: action.payload.quotes || state.contentAnalysis.quotes,
          keyMoments:
            action.payload.keyMoments || state.contentAnalysis.keyMoments,
          frames: action.payload.frames || state.contentAnalysis.frames,
          topics: action.payload.topics || state.contentAnalysis.topics,
          visualAnalysis:
            action.payload.visualAnalysis ||
            state.contentAnalysis.visualAnalysis,
        },
        presignedUrls: {
          ...state.presignedUrls,
          ...(action.payload.presignedUrls || {}),
        },
        frameUrls: {
          ...state.frameUrls,
          ...(action.payload.frameUrls || {}),
        },
      };

    case ACCUMULATE_VISUAL_ASSETS_DATA:
      console.log("contentComposerReducer - Accumulating VisualAssets data:", {
        quoteCardsCount: action.payload.quoteCards?.length || 0,
        carouselsCount: action.payload.carousels?.length || 0,
      });
      return {
        ...state,
        visualAssets: {
          quoteCards:
            action.payload.quoteCards || state.visualAssets.quoteCards,
          carousels: action.payload.carousels || state.visualAssets.carousels,
          storyCovers:
            action.payload.storyCovers || state.visualAssets.storyCovers,
          thumbnails:
            action.payload.thumbnails || state.visualAssets.thumbnails,
        },
        presignedUrls: {
          ...state.presignedUrls,
          ...(action.payload.presignedUrls || {}),
        },
      };

    case ACCUMULATE_TEXT_CONTENT_DATA:
      console.log("contentComposerReducer - Accumulating TextContent data");
      return {
        ...state,
        textContent: {
          blog: action.payload.blog || state.textContent.blog,
          twitterThread:
            action.payload.twitterThread || state.textContent.twitterThread,
          linkedInArticle:
            action.payload.linkedInArticle || state.textContent.linkedInArticle,
          newsletter: action.payload.newsletter || state.textContent.newsletter,
          descriptions:
            action.payload.descriptions || state.textContent.descriptions,
          metadata: action.payload.metadata || state.textContent.metadata,
        },
        presignedUrls: {
          ...state.presignedUrls,
          ...(action.payload.presignedUrls || {}),
        },
      };

    case ACCUMULATE_VIDEO_SEGMENTS_DATA:
      console.log("contentComposerReducer - Accumulating VideoSegments data:", {
        segmentsCount: action.payload.segments?.length || 0,
      });
      return {
        ...state,
        videoSegments: {
          segments: action.payload.segments || state.videoSegments.segments,
          s3Keys: {
            ...state.videoSegments.s3Keys,
            ...(action.payload.s3Keys || {}),
          },
        },
        presignedUrls: {
          ...state.presignedUrls,
          ...(action.payload.presignedUrls || {}),
        },
      };

    case CLEAR_CONTENT_COMPOSER_DATA:
      console.log("contentComposerReducer - Clearing all ContentComposer data");
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default contentComposerReducer;
